import { map, flatten, omit, concat } from 'lodash'
import { http, queryString } from 'utils'

// User mutation imports.
import { SET_TAGS, ADD_TAG, SET_PAGINATION_DATA } from 'vx/mutations'

// User state.
const state = {
  tags: [],
  pagination: null
}

// getters.
const getters = {
  getTagId: (state) => (id) => {
    return state.tags.find(tag => tag.id === id)
  }
}

// User actions.
const actions = {

  /**
   * Get a list of tags.
   */
  async getTagsList ({ commit }, params = {}) {
    commit(SET_TAGS, [])
    commit(SET_PAGINATION_DATA, null)

    const response = await http.get('tags', { params })

    commit(SET_TAGS, response.data.data)
    commit(SET_PAGINATION_DATA, response.data.meta)

    return response
  },

  addTag ({ commit }, payload) {
    return http.post(`tags`, payload).then(response => {
      commit(ADD_TAG, response.data)

      return response
    })
  },
}

// User state mutations.
const mutations = {

  /**
  * Set the stages state.
  */
  [SET_TAGS] (state, tags) {
    state.tags = tags
  },

  [ADD_TAG] (state, tag) {
    state.tags.push(tag)
  },

  [SET_PAGINATION_DATA] (state, data) {
    state.pagination = data
  },
}

// Export our state, getters, actions, mutations, and modules.
export default {
  namespaced: true, state, getters, actions, mutations
}
